import QueryResults from "./QueryResults";

export default class QueryResults_Cineteca extends QueryResults {
  constructor(qb, collectionName, target, resultsProvider, callback, type, additionalFields) {
    super(qb, collectionName, target, resultsProvider, callback, additionalFields);
    this.type = type;
    this.createPanelTypes();
  }

  createPanelTypes() {
    const panel = jQuery("#template-types").clone();
    panel.removeAttr("id");
    this.target.append(panel);
    for (let name in QueryResults_Cineteca.FIELDS) {
      const entry = jQuery("#template-type-fields").clone();
      entry.removeAttr("id");
      entry.text(name);
      entry.click(() => {
        const oldType = this.type;
        this.type = name;
        this.changeView(oldType);
        jQuery(".is-active", panel).removeClass("is-active");
        entry.addClass("is-active");
      });
      if (name === this.type) {
        entry.addClass("is-active");
      }
      panel[0].querySelector(".types-container").append(entry[0]);
    }
  }

  changeView(oldType) {
    const oldfields = QueryResults_Cineteca.FIELDS[oldType];
    this.grid.setColumnsVisible(oldfields, false);
    const newfields = QueryResults_Cineteca.FIELDS[this.type];
    this.grid.setColumnsVisible(newfields, true);
    // Pezza per riadattare la prima volta le colonne (è da fare meglio)
    if (!this["shown_" + this.type]) {
      this["shown_" + this.type] = true;
      this.doResize();
    }
  }

  getColumns() {
    let columnDefs = [
      // Filmografia
      this.fr.fieldFilmografia(),
      // Apri scheda
      this.fr.fieldCta(this.collectionName, this.dispatch.bind(this)),
      // Media
      this.fr.fieldMedia(),
      // Customs
      this.fr.filmografiaNCTN(),
      this.fr.filmografiaTitolo(),
      this.fr.filmografiaData(),
      this.fr.filmografiaRegista(),

      // Inventario
      this.fr.fieldList("av_inventario_INV", "Inventario", 1, null, null, "numero_INVN", null, null, null, { hide: this.isHidden("av_inventario_INV") }),
      // Collocazione
      this.fr.fieldPlain("collocazione_UBC", "Collocazione", 1, { hide: this.isHidden("collocazione_UBC") }),
      // Codice univoco
      this.fr.fieldMultiple("codice_regione_NCTR", "Codice univoco", 1, ["codice_regione_NCTR", "numero_catalogo_generale_NCTN", "livello_RVEL"], "<br>", { hide: this.isHidden("codice_regione_NCTR") }),
      // Titoli degli oggetti
      this.fr.fieldPlain("label", "Titoli degli oggetti", 2, { hide: this.isHidden("label") }),
      // Versione (EDCV)
      this.fr.fieldList("versione_EDCV", "Versione (EDCV)", 1, null, null, null, null, null, null, { hide: this.isHidden("versione_EDCV") }),
      // Lingua (EDCL) TROPPO CUSTOM PER ESSERE GESTITO DALLA LIBRERIA, bisognerà ripensare alla gestione delle viste
      {
        field: "lingua_EDCL",
        headerName: this.fr.getLabel("lingua_EDCL", "Lingua (EDCL)"),
        hide: this.isHidden("lingua_EDCL"),
        flex: 1,
        cellRenderer: (params) => {
          // Crea un contenitore div per tutti gli elementi
          const container = document.createElement("div");
          const a = this.fr.getField(params.value);
          a.forEach((item) => {
            const div = document.createElement("div");
            div.classList.add("grid-elemento-cliccabile");
            div.textContent = item;
            div.onclick = () => {
              this.dispatch(QueryResults.EVENT_LOOK_FOR, { name: item, context: params.colDef.headerName, type: "CINETECA_lingua_EDCL", viewType: this.type });
            };
            container.appendChild(div);
          });
          return container;
        },
      },
      // Definizione
      this.fr.fieldPlain("definizione_oggetto_OGTD", "Definizione", 2, { hide: this.isHidden("definizione_oggetto_OGTD") }),
      // SUPPORTO VIDEO (OGV)
      this.fr.fieldMultiple("supporto_OGVU", "Supporto video", 3, ["supporto_OGVU", "colore_OGVR", "durata_OGVD", "fonte_OGVF", "contenitore_OGVE", "note_tecniche_OGVN", "sonoro_OGVS"], "<br>", { hide: this.isHidden("supporto_OGVU") }),
      // FONTE COPIA (EDF)
      this.fr.fieldMultiple("fonte_EDFF", "FONTE COPIA (EDF)", 3, ["fonte_EDFF", "specifiche_fonte_EDFS", "ente_personaproprietario_EDFE", "note_EDFN"], "<br>", { hide: this.isHidden("fonte_EDFF") }),
      // Tipologia di materiale (OGPM)
      this.fr.fieldList("tipologia_materiale_OGPM", "Tipologia di materiale (OGPM)", 1, null, null, null, null, null, null, { hide: this.isHidden("tipologia_materiale_OGPM") }),
      /*{
        field: "tipologia_materiale_OGPM",
        headerName: this.getLabel("tipologia_materiale_OGPM", "Tipologia di materiale (OGPM)"),
        hide: this.isHidden("tipologia_materiale_OGPM"),
        flex: 2,
        cellRenderer: (params) => {
          const a = this.getField(params.value);  
          return a.map((entry) => entry).join("<br>");
        },
      },*/
      // SPECIFICHE PELLICOLA
      this.fr.fieldMultiple("fonte_EDFF", "SPECIFICHE PELLICOLA", 3, ["formato_OGPF", "aspect_ratio_OGPA", "lunghezza_OGPL", "durata_OGPD", "velocita_OGPV", "unita_fisica_OGPU", "contenitore_OGPE"], "<br>", { hide: this.isHidden("fonte_EDFF") }),
      // Sonoro (OGPS)
      this.fr.fieldPlain("sonoro_OGPS", "Sonoro (OGPS)", 1, { hide: this.isHidden("sonoro_OGPS") }),
      // Intervento restauri
      this.fr.fieldList("intervento_restauri", "Intervento restauri", 2, null, null, ["tipologia_intervento_RSIT", "data_intervento_RSID"], "<br>", null, null, { hide: this.isHidden("intervento_restauri") }),
      // CAMPIONARI
      this.fr.fieldMultiple("supporto_cartaceo_OGCC", "Campionari", 3, ["supporto_cartaceo_OGCC", "tecnica_assemblaggio_OGCA", "iscrizioni_OGCI", "formato_fotogrammi_OGCF", "numero_fotogrammi_applicati_OGCP", "numero_fotogrammi_staccati_OGCS", "base_supporto_fotogrammi_OGCB"], "<br>", { hide: this.isHidden("supporto_cartaceo_OGCC") }),
      // Colore fotogrammi (OGCR)
      this.fr.fieldPlain("colore_fotogrammi_OGCR", "Colore fotogrammi (OGCR)", 1, { hide: this.isHidden("colore_fotogrammi_OGCR") }),
      // Specifiche sistema colore fotogrammi (OGCW)
      this.fr.fieldList("specifiche_sistema_colore_fotogrammi_OGCW", "Specifiche sistema colore fotogrammi (OGCW)", 1, null, null, null, null, null, null, { hide: this.isHidden("specifiche_sistema_colore_fotogrammi_OGCW") }),
      // Note tecniche (OGCN)
      this.fr.fieldPlain("note_tecniche_OGCN", "Note tecniche (OGCN)", 3, { hide: this.isHidden("note_tecniche_OGCN") }),
    ];

    columnDefs = this.addAdditionalFields(columnDefs);
    this.columnDefs = columnDefs;
    return columnDefs;
  }

  isHidden(field) {
    const list = QueryResults_Cineteca.FIELDS[this.type];
    return list.indexOf(field) === -1;
  }
}

QueryResults_Cineteca.TYPE_CAMPIONARI = "campionari";
QueryResults_Cineteca.TYPE_VIDEO = "video";
QueryResults_Cineteca.TYPE_PELLICOLE = "pellicole";

QueryResults_Cineteca.FIELDS = {
  campionari: ["av_inventario_INV", "codice_regione_NCTR", "label", "versione_EDCV", "lingua_EDCL", "definizione_oggetto_OGTD", "supporto_cartaceo_OGCC", "colore_fotogrammi_OGCR", "specifiche_sistema_colore_fotogrammi_OGCW", "note_tecniche_OGCN"],
  video: ["codice_regione_NCTR", "av_inventario_INV", "collocazione_UBC", "label", "versione_EDCV", "lingua_EDCL", "definizione_oggetto_OGTD", "supporto_OGVU", "fonte_EDFF"],
  pellicole: ["av_inventario_INV", "collocazione_UBC", "label", "definizione_oggetto_OGTD", "versione_EDCV", "lingua_EDCL", "tipologia_materiale_OGPM", "fonte_EDFF", "sonoro_OGPS", "intervento_restauri"],
};

QueryResults_Cineteca.QUERY_lingua_EDCL = {
  id: "QN1731405366086",
  Field: {
    _path: "/",
    _label: "/",
    Name: "",
    Label: "",
    Relation: null,
    Flags: 255,
    IsArray: false,
    Type: "complex",
    Lookup: null,
  },
  Occurency: "MUST",
  type: "QueryNodeBoolean",
  AdmitExists: false,
  Operator: "AND",
  Clauses: [
    {
      id: "QN1731405366087",
      Field: {
        _path: "/lingua_EDCL",
        _label: "/lingua_EDCL",
        Name: "lingua_EDCL",
        Label: "lingua_EDCL",
        Relation: null,
        Flags: 7,
        IsArray: true,
        Type: "text",
      },
      Occurency: "MUST",
      type: "QueryNodeTerm",
      Value: "dummy",
      Compare: "tPHRASEw",
    },
  ],
  CollectionName: "CINETECA_coll",
};
